module.exports = __webpack_public_path__ + "files/1687c3611e637ade3fb06b612798345e.png";